import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import AppNav from '../../components/appNav';

export default function CheckoutCancel() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [paymentInfo, setPaymentInfo] = useState(null);

    useEffect(() => {
        // Captura parâmetros da URL retornados pela Asaas
        const externalReference = searchParams.get('externalReference');
        const paymentId = searchParams.get('id');

        if (externalReference || paymentId) {
            setPaymentInfo({
                externalReference,
                paymentId
            });
        }
    }, [searchParams]);

    const handleBackToEvents = () => {
        navigate('/');
    };

    const handleTryAgain = () => {
        // Volta para a página anterior (formulário de inscrição)
        navigate('/');
    };

    return (
        <>
            <AppNav />
            <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
                <Paper 
                    elevation={3} 
                    sx={{ 
                        p: 4, 
                        textAlign: 'center',
                        borderRadius: 2
                    }}
                >
                    <CancelOutlinedIcon 
                        sx={{ 
                            fontSize: 80, 
                            color: 'warning.main',
                            mb: 2 
                        }} 
                    />
                    
                    <Typography 
                        variant="h4" 
                        component="h1" 
                        gutterBottom
                        sx={{ fontWeight: 'bold', color: 'warning.main' }}
                    >
                        Pagamento Cancelado
                    </Typography>

                    <Typography 
                        variant="body1" 
                        color="text.secondary" 
                        sx={{ mb: 3 }}
                    >
                        O processo de pagamento foi cancelado.
                    </Typography>

                    {paymentInfo && paymentInfo.externalReference && (
                        <Box 
                            sx={{ 
                                mt: 3, 
                                p: 2, 
                                bgcolor: 'grey.100', 
                                borderRadius: 1,
                                textAlign: 'left'
                            }}
                        >
                            <Typography variant="body2" gutterBottom>
                                <strong>Referência:</strong>
                            </Typography>
                            
                            <Typography variant="body2" color="text.secondary">
                                Código: {paymentInfo.externalReference}
                            </Typography>
                        </Box>
                    )}

                    <Typography 
                        variant="body2" 
                        color="text.secondary" 
                        sx={{ mt: 3, mb: 3 }}
                    >
                        Nenhuma cobrança foi realizada. Você pode tentar novamente quando desejar.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
                        <Button 
                            variant="outlined" 
                            color="primary" 
                            size="large"
                            onClick={handleBackToEvents}
                        >
                            Voltar para Eventos
                        </Button>
                        
                        <Button 
                            variant="contained" 
                            color="primary" 
                            size="large"
                            onClick={handleTryAgain}
                        >
                            Tentar Novamente
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </>
    );
}
